module.exports = __webpack_public_path__ + "media/images/pic/brodno/team-hero-1bb1658ff970bfd329f583b38caea7eb.webp";